<!--
 * @Author: vince
 * @Date: 2021-08-18 09:23:11
 * @LastEditors: vince
 * @LastEditTime: 2021-09-10 11:20:51
 * @Description: 
-->
<template>
	<el-select v-loading="loading" :size="size" :value="dicCodeTemp" placeholder="请选择" value-key="dicCode" clearable @change="change">
		<el-option v-for="item in options" :label="item.dicName" :value="item.dicCode" :key="item.dicCode"></el-option>
	</el-select>
</template>

<script>
import { mapGetters } from "vuex";
import { getData } from "@/http/fetch.js";
import { string } from "../../utils/html-docx";

export default {
	name: "dicCodeSelector",
	model: {
		prop: "value",
		event: "change"
	},
	data() {
		return {
			loading: false,
			options: [],
			dicCodeTemp: ""
		};
	},
	computed: {
		...mapGetters(["schoolCode"])
	},
	props: {
		dicType: {
			require: true,
			type: String
		},
		value: {
			type: Object | Array | String | Number
		},
		size: {
			require: true,
			type: String,
			default: "small"
		}
	},
	watch: {
		value: {
			handler(v) {
				this.dicCodeTemp = v+"";
			},
			immediate: true
		}
	},
	created() {
		this.getDictionaryList();
	},
	methods: {
		async getDictionaryList() {
			this.loading = true;
			return new Promise((resolve, reject) => {
				getData("/core/dic/getDictionaryList-page", {
					dicType: this.dicType,
					pageNum: 1,
					pageSize: -1
				})
					.then(res => {
						if (res.length > 0) {
							res = res.map(m => {
								return {
									dicCode: m.dicCode,
									dicName: m.dicName
								};
							});
							this.options = res;
							resolve(res);
						} else {
							this.options = [];
							reject();
						}
					})
					.catch(e => {
						reject();
					})
					.finally(() => {
						this.loading = false;
					});
			});
		},
		change(v) {
			this.dicCodeTemp = v;
			this.$emit("change", v);
		}
	}
};
</script>

<style>
</style>